import { ContactUpdateField } from "@/type/core/contact/contact.types";
import { createEvent } from "effector";

export const setContactField =
  createEvent<ContactUpdateField[]>("SET_CONTACT_FIELD");
